import React from "react";
import { connect } from "react-redux";
import { Button, NumberBox, ValidationGroup } from "devextreme-react";
import { lastStep, nextStep, setDataNewComplain } from "../../actions";
import TextField from "../../../../../../Shared/fields/TextField";
import validaciones from "../../../../../../../helpers/validaciones";
import SelectField from "../../../../../../Shared/fields/SelectField";

class DatosEmpresa extends React.PureComponent {
  // constructor(props) {
  //   super(props);

  //   // this.topRef = React.createRef();
  // }

  componentDidMount = () => {
    if (this.props.jsonData &&
      this.props.jsonData.formDatosEmpresa &&
      !this.props.jsonData.formDatosEmpresa.RutEmpresa) {
      const form = { ...this.props.jsonData };
      form.formDatosEmpresa = this.props.companyData;
      this.props.dispatch(setDataNewComplain(form));
    }
  }

  handleBack = () => {
    this.props.dispatch(lastStep());
  }

  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      // this.topRef.current.scrollIntoView();
      // this.props.onSave(false);
      this.props.dispatch(nextStep());
    }
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };

    switch (e.element.id) {
      case "RutEmpresa": {
        let errorTxt = "";
        let isValidRut;
        if (validaciones.validateRut(e.value) === false) {
          errorTxt = "Formato de rut inválido";
          isValidRut = false;
          jsonData.formDatosEmpresa.RutEmpresa = e.value;
        } else {
          jsonData.formDatosEmpresa.RutEmpresa = validaciones.formatRut(e.value, { showDots: true, showHyphen: true });
          isValidRut = true;
        }

        e.component.option({
          validationError: { message: errorTxt },
          isValid: isValidRut,
        });

        break;
      }
      case "NombreRazon": {
        jsonData.formDatosEmpresa.NombreRazon = e.value;
        break;
      }
      case "TipoEmpresa": {
        jsonData.formDatosEmpresa.TipoEmpresa = e.value;
        break;
      }
      case "ActividadEconomica": {
        jsonData.formDatosEmpresa.Actividad = e.value;
        break;
      }
      case "ActividadPrincipal": {
        jsonData.formDatosEmpresa.ActividadPrincipal = e.value;
        break;
      }
      case "Propiedad": {
        jsonData.formDatosEmpresa.Propiedad = e.value;
        break;
      }
      case "TotalHombres": {
        jsonData.formDatosEmpresa.TotalHombres = e.value;
        break;
      }
      case "TotalMujeres": {
        jsonData.formDatosEmpresa.TotalMujeres = e.value;
        break;
      }
      default:
        break;
    }

    this.props.dispatch(setDataNewComplain(jsonData));
  }

  render() {
    return (
      <ValidationGroup className="row">
        <div className="col-12 newDenuncia-title"> {/* ref={this.topRef}> */}
          <h2>Datos de la empresa</h2>
          <p>Completa los datos para pasar a la siguiente sección</p>
        </div>
        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Información de la empresa</h4>
        </div>
        <div className="col-12">
          <TextField
            label="Rut"
            id="RutEmpresa"
            onChange={this.handleChange}
            value={this.props.jsonData.formDatosEmpresa.RutEmpresa}
            disabled={!!this.props.jsonData.formDatosEmpresa.RutEmpresa}
          />
          <TextField
            id="NombreRazon"
            maxLength={80}
            label="Nombre o razón social"
            onChange={this.handleChange}
            value={this.props.jsonData.formDatosEmpresa.NombreRazon}
            disabled={!!this.props.jsonData.formDatosEmpresa.NombreRazon}
          />

          <SelectField
            label="Tipo de empresa"
            id="TipoEmpresa"
            required
            value={this.props.jsonData.formDatosEmpresa.TipoEmpresa}
            onChange={this.handleChange}
            displayExpr="DescripcionTipoEmpresa"
            items={this.props.listaTipoEmpresa}
            acceptCustomValue
          />

          <SelectField
            label="Actividad económica"
            id="ActividadEconomica"
            required
            value={this.props.jsonData.formDatosEmpresa.Actividad}
            onChange={this.handleChange}
            displayExpr="DescripcionActividadEconomica"
            items={this.props.listaActividadEconomica}
            acceptCustomValue
          />

          {this.props.jsonData.formDatosEmpresa.TipoEmpresa && this.props.jsonData.formDatosEmpresa.TipoEmpresa.IdTipoEmpresa !== 1 && (
            <SelectField
              label="Actividad económica principal de la empresa"
              id="ActividadPrincipal"
              required
              optional
              value={this.props.jsonData.formDatosEmpresa.ActividadPrincipal}
              acceptCustomValue
              onChange={this.handleChange}
              items={this.props.listaActividadEconomica}
              displayExpr="DescripcionActividadEconomica"
            />
          )}

          <SelectField
            label="Propiedad de la empresa"
            id="Propiedad"
            required
            value={this.props.jsonData.formDatosEmpresa.Propiedad}
            onChange={this.handleChange}
            items={this.props.listaPropiedadEmpresa}
            displayExpr="DescripcionPropiedadEmpresa"
            acceptCustomValue
          />

          <div className="row zero-vertical">
            <div className="col-6">
              <div className="field-newDenuncia">
                <h3><p>Total trabajadores hombres</p></h3>
                <NumberBox
                  id="TotalHombres"
                  inputAttr={{ maxLength: 10 }}
                  value={this.props.jsonData.formDatosEmpresa.TotalHombres}
                  onValueChanged={this.handleChange}
                />
              </div>

            </div>
            <div className="col-6 zero-left">
              <div className="field-newDenuncia">
                <h3><p>Total trabajadores mujeres</p></h3>
                <NumberBox
                  inputAttr={{ maxLength: 10 }}
                  id="TotalMujeres"
                  value={this.props.jsonData.formDatosEmpresa.TotalMujeres}
                  onValueChanged={this.handleChange}
                />
              </div>

            </div>
          </div>

          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />
          <Button
            text="Siguiente"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />
        </div>
      </ValidationGroup>
    );
  }
}
const mapStateToProps = (state) => ({
  UserInfo: state.userRegister.UserInfo,
  jsonData: state.denuncias.jsonData,
  companyData: state.denuncias.dataCompany,
  listaEmpresas: state.global.listaEmpresas,
  listaTipoEmpresa: state.global.listaTipoEmpresa,
  listaActividadEconomica: state.global.listaActividadEconomica,
  listaPropiedadEmpresa: state.global.listaPropiedadEmpresa,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DatosEmpresa);
